import { format } from "date-fns";
import { enUS, es, ko, zhTW, zhCN, ja } from "date-fns/locale";
import { getUserTimezoneAbbreviation } from "i18n/timezone";

const currentLanguageToDateFnsLocaleMap = (currentLocale: string) => {
  switch (currentLocale) {
    case "ja":
      return { locale: ja, format: "MM'月'dd'日（'EEE'）'HH:mm" };
    case "en":
      return { locale: enUS, format: "MMM d (EEE) HH:mm" };
    case "es":
      return { locale: es, format: "d 'de' MMM (EEE) HH:mm" };
    case "ko":
      return { locale: ko, format: "M'월' d'일 ('EEE') 'HH:mm" };
    case "zh_cn":
      return { locale: zhCN, format: "MM'月'dd'日 ('EEE') 'HH:mm" };
    case "zh_tw":
      return { locale: zhTW, format: "MM'月'dd'日 ('EEE') 'HH:mm" };
    default:
      return { locale: ja, format: "MM'月'dd'日（'EEE'）'HH:mm" };
  }
};

const formatDateTime = (dateTime: number, currentLanguage: string): string => {
  const date = new Date(dateTime);

  const { locale, format: fmsFormat } =
    currentLanguageToDateFnsLocaleMap(currentLanguage);

  return format(date, fmsFormat, {
    locale,
  });
};

export const startDatetimeAndEndDatetime = (
  startDateTime: number,
  endDateTIme: number,
  currentLanguage: string
) => {
  const timeZone = getUserTimezoneAbbreviation();
  const formattedTimezone = timeZone !== "" ? ` (${timeZone})` : "";

  return `${formatDateTime(startDateTime, currentLanguage)} - ${formatDateTime(endDateTIme, currentLanguage)}${formattedTimezone}`;
};
